
import { postApiAuthRefreshToken } from '@/shared/apis/fastmile/generated/auth/auth'
import { ThunkApiContext } from '@/shared/store'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { clearUserSession } from '../sessionSlice'

type RefreshTokenResult = {
  accessToken: string | null
  refreshToken: string | null
  token: string | null
}

export const refreshUserToken = createAsyncThunk<RefreshTokenResult, undefined, ThunkApiContext>('user/refreshUserToken', async (_, { dispatch, getState, rejectWithValue }) => {
  const state = getState()
  const { refreshToken } = state.session


  if (!refreshToken) {
    dispatch(clearUserSession())

    return rejectWithValue('No refresh token available')
  }

  try {
    const result = await postApiAuthRefreshToken({
      refreshToken: refreshToken,
    })

    if (!result.accessToken) {
      dispatch(clearUserSession())

      return rejectWithValue('Invalid refresh token response')
    }

    return {
      accessToken: result.accessToken,
      refreshToken: result.refreshToken,
      token: result.token,
    }
  } catch (err) {
    dispatch(clearUserSession())
    console.error(err)

    return rejectWithValue('Failed to refresh token')
  }
})